// Show All , Two Arrows in home Page
// Used in The Following:
// 1- Today's Offers
// 2- ProductsBy Component
import { useRouter } from "next/router";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

export function ButtonArrows({
  t,
  swiper,
  multi,
  active,
  // show = true,
  dynamicSeeMore,
  data,
  singleLink,
}) {
  const { push, locale } = useRouter();

  return (
    <div className="flex items-center">
      <div
        className={`flex items-center ${
          locale === "en" ? "flex-row" : "flex-row-reverse"
        }`}
      >
        <IoIosArrowBack
          onClick={() => swiper.slidePrev()}
          size="27px"
          className="cursor-pointer max-[991px]:hidden"
        />
        <IoIosArrowForward
          onClick={() => swiper.slideNext()}
          size="27px"
          className="cursor-pointer max-[991px]:hidden"
        />
      </div>
      {dynamicSeeMore ? (
        <button
          suppressHydrationWarning
          aria-label="Category Button"
          onClick={
            data
              ? () => push(`/${data[active]["category-url"]}`)
              : () => push("")
          }
          className={`p-3 ${
            multi && "max-[768px]:hidden"
          } max-[768px]:px-2 max-[768px]:text-sm border  text-blue
          rounded-sm transition-all duration-200 hover:bg-blue
          hover:text-white min-w-[120px]`}
        >
          {t("show")}
        </button>
      ) : singleLink ? (
        <button
          suppressHydrationWarning
          aria-label="Show All button"
          onClick={() => push(`/${singleLink}`)}
          className={`p-3 ${
            multi && "max-[768px]:hidden"
          } max-[768px]:px-2 max-[768px]:text-sm border  text-blue
  rounded-sm transition-all duration-200 hover:bg-blue
  hover:text-white min-w-[120px]`}
        >
          {t("show")}
        </button>
      ) : null}
    </div>
  );
}
